import { Alert, Snackbar } from "@mui/material";
import React from "react";

const ErrorSnackbarAlert = ({ children, open, onClose }) => {
  // Don't show snackbar if error message is empty or only whitespace
  const shouldShow = open && children && children.toString().trim() !== "";

  return (
    <Snackbar open={shouldShow} autoHideDuration={6000} onClose={onClose}>
      <Alert
        onClose={onClose}
        severity={"error"}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {children}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbarAlert;
